import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from './Navbar';
//import { Container, ListGroup, Row } from "react-bootstrap";

import './css/Donate.css';

function Donate() {

    return (
        <div className="grid gap-0 row-gap-3">

            <div className="p-5">
                <Navbar />
            </div>

            <div className="ml-5">
                <h1 className="label display-6">Donate using cheques</h1>
                <p>
                    Write your cheque out to “The Buddhist Meditation Association of Victoria“ and post it to:<br /><br />
                        The Buddhist Meditation Association of Victoria Inc<br />
                        43, Hemmings Street<br></br>
                        Dandenong, VIC 3175

                    <br/><br/>
                    NOTE:
                    <p>If you want a receipt issued for the payment, please enclose a note with your name, postal address or email address & contact number with the cheque.</p>
                    <hr></hr>
                </p>

                <h1 className="label display-6">Donate using bank deposit or Electronic Funds Transfer</h1>
                <br />
                <table className="table-bordered border-primary">
                    <tbody>
                        <tr>
                            <th scope="row"><h5>Account Name</h5></th>
                            <td><h5 className="ml-5">The Buddhist Meditation Association of Victoria</h5></td>
                        </tr>
                        <tr>
                            <th scope="row"><h5>BSB Number</h5></th>
                            <td><h5 className="ml-5">013289</h5></td>
                        </tr>
                        <tr>
                            <th scope="row"><h5>Account Number</h5></th>
                            <td><h5 className="ml-5">285376107</h5></td>
                        </tr>
                        <tr>
                            <th scope="row"><h5>Bank Name</h5></th>
                            <td><h5 className="ml-5">ANZ</h5></td>
                        </tr>
                        <tr>
                            <th scope="row"><h5>Branch Name</h5></th>
                            <td><h5 className="ml-5">Dandenong Plaza Branch</h5></td>
                        </tr>
                    </tbody>
                </table>

            </div>

        </div>
    )
}
export default Donate;